import { render } from "./Funcionalidades.vue?vue&type=template&id=0f96a714&scoped=true"
import script from "./Funcionalidades.vue?vue&type=script&lang=js"
export * from "./Funcionalidades.vue?vue&type=script&lang=js"

import "./Funcionalidades.vue?vue&type=style&index=0&id=0f96a714&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f96a714"]])

export default __exports__